import type { ColumnIndex, LayoutInterval } from 'owa-calendar-surface-dategrid';

/**
 * Gets the layout interval that corresponds to the given column.
 * @param columnIndex The index of the column we are interested in.
 * @param columnLength The length of the columns in the current view.
 * @returns A layout interval with the inclusive start offset of the column
 * and the exclusive end offset of the column. As such, the end of one column
 * is the start of the next column.
 */
export function getColumnInterval(columnIndex: ColumnIndex, columnLength: number): LayoutInterval {
    return {
        start: columnIndex * columnLength,
        end: (columnIndex + 1) * columnLength,
    };
}
